import { observer } from 'mobx-react';
import GenericSortFilter from '../../GenericSortFilter';
import { ProductLicensesStore } from './Store';
import { licenseFilterSelectOptions } from './Types';

interface Props {
  store: ProductLicensesStore;
}

function LicensesFilter({ store }: Props) {
  switch (store.state.kind) {
    case 'waiting':
    case 'loading':
      return (
        <div className="mr-4 w-48">
          <GenericSortFilter
            labelText="Licenses"
            options={licenseFilterSelectOptions}
            disabled
            parameters={store.state.searchParameters}
            updatingParameters={store.updatingSearchParameters}
            sortFilterKey={'licenses'}
          />
        </div>
      );
    case 'ready':
      return (
        <div className="mr-4 w-48">
          <GenericSortFilter
            labelText="Licenses"
            options={licenseFilterSelectOptions}
            parameters={store.state.searchParameters}
            updatingParameters={store.updatingSearchParameters}
            sortFilterKey={'licenses'}
          />
        </div>
      );
    case 'loading-error':
      return <></>;
  }
}

export default observer(LicensesFilter);
